import type { ReactNode } from 'react'
import type { PageContext } from 'vike/types'
import '../src/themes/global.css'

interface PageShellProps {
  children: ReactNode
  pageContext: PageContext
}

export function PageShell({ children }: PageShellProps) {
  return (
    <div className="persona-os">
      {/* CRT Overlay for scanline effects */}
      <div className="crt-overlay" aria-hidden="true">
        <div className="crt-scanlines" />
      </div>

      {/* Main content area */}
      <main className="desktop">
        {children}
      </main>
    </div>
  )
}
